
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[event_id]",
      function () {
        return require("private-next-pages/[event_id]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[event_id]"])
      });
    }
  